import axios from "axios";
import { notification } from "antd";

const PORT = "9040";
const PORT_SALES = "8087";

export const BASE =
  process.env.REACT_APP_ENV == "devlopment"
    ? "http://65.1.90.9"
    : "https://app.creditwisecapital.in"; //"https://app.creditwisecapital.in";
const baseURL =
  process.env.REACT_APP_ENV == "devlopment" ? `${BASE}:${PORT}` : `${BASE}`;
const baseURLSales =
  process.env.REACT_APP_ENV == "devlopment"
    ? `${BASE}:${PORT_SALES}`
    : `${BASE}`;

const handleError = (err) => {
  const errorResponse = {
    data: { message: "Something went wrong.", error: true },
  };

  if (err.message === "Network Error") {
    errorResponse.data.message = err.message;
    return errorResponse;
  }
  const { response } = err;
  if (response.status === 500) {
    try {
      const res = JSON.parse(response.data.split("}")[1] + "}");
      if (res.statusCode === "401") {
        // window.location.href = REDIRECT_URL;
        errorResponse.data.message = res.message;
        return errorResponse;
      }
    } catch (err) {}
  }
  return errorResponse;
};

export const getFilePath = (filePath) =>
  filePath?.replace("/var/www/html", BASE);

export const get = async (url) => {
  let apiUrl = baseURL + url;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Access-Control-Allow-Origin": "*",
  };
  const axiosObj = {
    method: "get",
    url: apiUrl,
    headers,
  };
  try {
    return await axios(axiosObj);
  } catch (err) {
    const response = handleError(err);
    return response;
  }
};

export const post = async (url, bodyObj = {}, mediaFile = false) => {
  let apiUrl = baseURL + url;
  let header = {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Access-Control-Allow-Origin": "*",
  };
  if (mediaFile) {
    let formData = new FormData();
    Object.keys(bodyObj).map((key) => {
      formData.append(key, bodyObj[key]);
    });
    bodyObj = formData;

    header["Content-Type"] = "multipart/form-data";
  }

  try {
    return await axios.post(apiUrl, bodyObj, {
      headers: header,
    });
  } catch (err) {
    return handleError(err);
  }
};
export const postSales = async (
  url,
  bodyObj = {},
  mediaFile = false,
  isPrivate = false
) => {
  if (isPrivate) {
    let response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "x-api-key": "WEhMRi7Mvl1A0695pxEcN7kpmPzIE7ot5D9Xj6A0",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        ...bodyObj,
      }),
    }).catch((re) => {
      notification.error({ message: "Something Went Wrong" });
    });
    if (response?.ok) {
      // if HTTP-status is 200-299
      // get the response body (the method explained below)
      let json = await response.json();
      return json;
    }
  } else {
    let apiUrl = baseURLSales + url;
    let header = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    };
    if (mediaFile) {
      let formData = new FormData();
      Object.keys(bodyObj).map((key) => {
        formData.append(key, bodyObj[key]);
      });
      bodyObj = formData;

      header["Content-Type"] = "multipart/form-data";
    }

    try {
      return await axios.post(apiUrl, bodyObj, {
        headers: header,
      });
    } catch (err) {
      return handleError(err);
    }
  }
};
